const DEFAULT_APP_STATUS = {
  maintenanceMode: false,
  maintenanceMessage: "",
  bannerEnabled: false,
  bannerMessage: "",
  updatedAt: null,
};

const DEFAULT_POLL_INTERVAL_MS = 60000;

const toBoolean = (value) => value === true;

const normalizeAppStatus = (data = {}) => ({
  maintenanceMode: toBoolean(data.maintenanceMode),
  maintenanceMessage: data.maintenanceMessage || "",
  bannerEnabled: toBoolean(data.bannerEnabled),
  bannerMessage: data.bannerMessage || "",
  updatedAt: data.updatedAt || null,
});

export const areAppStatusesEqual = (left = DEFAULT_APP_STATUS, right = DEFAULT_APP_STATUS) =>
  left.maintenanceMode === right.maintenanceMode &&
  left.maintenanceMessage === right.maintenanceMessage &&
  left.bannerEnabled === right.bannerEnabled &&
  left.bannerMessage === right.bannerMessage &&
  left.updatedAt === right.updatedAt;

export const getDefaultAppStatus = () => ({ ...DEFAULT_APP_STATUS });

export const getAppStatusPollMs = () => {
  const rawValue = Number(process.env.REACT_APP_APP_STATUS_POLL_MS);

  if (Number.isFinite(rawValue) && rawValue > 0) {
    return rawValue;
  }

  return DEFAULT_POLL_INTERVAL_MS;
};

export const fetchAppStatus = async (signal) => {
  const configUrl = process.env.REACT_APP_APP_STATUS_URL;

  if (!configUrl) {
    return getDefaultAppStatus();
  }

  const requestUrl = new URL(configUrl, window.location.origin);
  requestUrl.searchParams.set("ts", Date.now().toString());

  try {
    const response = await fetch(requestUrl.toString(), {
      cache: "no-store",
      headers: {
        Accept: "application/json",
      },
      signal,
    });

    if (!response.ok) {
      throw new Error(`Failed to load app status: ${response.status}`);
    }

    const data = await response.json();

    return normalizeAppStatus(data);
  } catch (error) {
    if (error.name !== "AbortError") {
      console.error("Unable to load app status", error);
    }

    return null;
  }
};
